
import {Box, FormHelperText} from '@mui/material';
import React from "react";
import CustomAddChipSearch from "../../../../../../../components/CustomAddChipSearch";
import {deviceListToLabel, getModelSimpleSearch} from "../../../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../../../components/buttons/IconButtons";
import {CustomTextField} from "../../../../../../../components/CustomTextField";
import DividerWithText from "../../../../../../../components/DividerWithText";
import {CustomStyleFormHelperText} from "../../../../../../../components/Styles";
import {TABLES} from "../../../../../../../Apis/Tables";
import CustomRadio from "../../../../../../../components/CustomRadio";
import {ATTENDANCE_GEOFENCE_MODE} from "../Model/Model";
import {ATTENDANCE_SERVICE} from "../../../../../../../reduxToolkit/EndPoints";
import {MODE_MODEL} from "../../../../../Devices/Model/Model";

/**
 * @Email : azpaata@ibl.mx
 * @Author: Arnulfo Ferro Zapata
 * @jobTittle: developer
 */
const DetailsStep = ({ t, disabled, handleChange, emptyFields, item, selectedList, setSelectedList }) => {
    const isValidRestriction = item.isValidMode();

    // On update, scope available devices to the current config; on create there is no config yet
    const availableDevicesApi = item?.geofenceConfigId
        ? `${ATTENDANCE_SERVICE.getGeofenceAvailableDevices}?configId=${item.geofenceConfigId}`
        : ATTENDANCE_SERVICE.getGeofenceAvailableDevices;

    // HandleChange coerces radio inputs to boolean, so the mode is sent as a plain field change
    const handleChangeMode = (mode) => handleChange({ target: { name: 'mode', value: mode } });

    return (
        <>
            <Box className='col-12'>
                <CustomTextField
                    id='txt_ds_name'
                    name='name'
                    trans='name'
                    required={true}
                    onChange={handleChange}
                    value={item?.name}
                    emptyFields={emptyFields}
                    disabled={disabled}
                />
            </Box>
            <Box className='col-12'>
                <CustomTextField
                    id='txt_ds_description'
                    name='description'
                    value={item?.description}
                    trans='description'
                    onChange={handleChange}
                    length={512}
                    required={true}
                    emptyFields={emptyFields}
                    multiline
                    rows={3}
                    disabled={disabled}
                />
            </Box>
            <div className={"col-12"}>
                <DividerWithText title={t('restrictions')} />
            </div>
            <div className={"col-12"}>
                <div className={`w-100 h-100 border-radius-8px pt-4 ${emptyFields && !isValidRestriction ? 'border-full-error-code-600 ' : ''}`}>
                    <Box className="col-12">
                        <CustomRadio
                            id="rbtn_ds_monitoring_only_none"
                            trans="monitoring_only_none"
                            name="mode"
                            value={ATTENDANCE_GEOFENCE_MODE.MONITORING_ONLY.id}
                            checked={item?.mode === ATTENDANCE_GEOFENCE_MODE.MONITORING_ONLY.id}
                            onChange={() => handleChangeMode(ATTENDANCE_GEOFENCE_MODE.MONITORING_ONLY.id)}
                            labelClassName="fs-14px font-color-general-950"
                            disabled={disabled}
                        />
                    </Box>

                    <Box className="col-12">
                        <CustomRadio
                            id="rbtn_ds_warning_mode_soft"
                            trans="warning_mode_soft"
                            name="mode"
                            value={ATTENDANCE_GEOFENCE_MODE.WARNING_MODE.id}
                            checked={item?.mode === ATTENDANCE_GEOFENCE_MODE.WARNING_MODE.id}
                            onChange={() => handleChangeMode(ATTENDANCE_GEOFENCE_MODE.WARNING_MODE.id)}
                            labelClassName="fs-14px font-color-general-950"
                            disabled={disabled}
                        />
                    </Box>

                    <Box className="col-12">
                        <CustomRadio
                            id="rbtn_ds_restricted_access_hard"
                            trans="restricted_access_hard"
                            name="mode"
                            value={ATTENDANCE_GEOFENCE_MODE.RESTRICTED_ACCESS.id}
                            checked={item?.mode === ATTENDANCE_GEOFENCE_MODE.RESTRICTED_ACCESS.id}
                            onChange={() => handleChangeMode(ATTENDANCE_GEOFENCE_MODE.RESTRICTED_ACCESS.id)}
                            labelClassName="fs-14px font-color-general-950"
                            disabled={disabled}
                        />
                    </Box>
                </div>

                <FormHelperText error={true} sx={CustomStyleFormHelperText(false)}>
                    {emptyFields && !isValidRestriction && t('select_one_option')}
                </FormHelperText>
            </div>

            <div className={"col-12 mb-2"}>
                <DividerWithText title={t('scope')} />
            </div>
            <div className={"row"}>
                <div className={"col-12 mb-3"}>
                    <p className={"fs-14px ibl-font-w-600 font-color-shades-950"}>{t('devices')}</p>
                </div>
                <div className={"col-12 col-lg-4"}>
                    <p className={"d-flex h-44px align-items-center fs-14px ibl-font-w-400 font-color-shades-950"}>{t('configure_which_devices')}</p>
                </div>
                <div className={"col-12 col-lg-8"}>
                    <CustomAddChipSearch
                        autocompleteId={'slt_ds_devices'}
                        buttonId={'btn_ds_add_device'}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        disabled={disabled}
                        label="devices"
                        emptyFields={emptyFields}
                        required={true}
                        reset={false}
                        hideButton={false}
                        keyId={"id"}
                        showSubSection={true}
                        sanitizeDataList={deviceListToLabel}
                        showRenderOption={true}
                        Icon={PersonChipBlack}
                        chipIcon={null}
                        api={availableDevicesApi}
                        bodyApi={getModelSimpleSearch(
                            TABLES.DEVICES,
                            { modeIds: [MODE_MODEL.ATTENDANCE, MODE_MODEL.ACCESS_AND_ATTENDANCE]}
                        )}
                    />
                </div>
            </div>

        </>
    );
};

export default DetailsStep;
